/* eslint-disable @trello/disallow-filenames */
import type { EventAttributes } from '@trello/atlassian-analytics';

import type { MoonshotSteps } from './campaigns';
import type { MoonshotOrganizationQuery } from './MoonshotOrganizationQuery.generated';
import type { MoonshotQuery } from './MoonshotQuery.generated';

export enum ExperimentVariations {
  CONTROL = 'control',
  NOT_ENROLLED = 'not-enrolled',
  EXPERIMENT = 'experiment',
}
export interface MoonshotSubmitFunction {
  (step?: MoonshotSteps, options?: { redirect?: boolean }): void;
}
export interface MoonshotDismissFunction {
  //We need to not redirect, in the case that we are clicking the Standard CTA on Upsell -
  //in that case we want to dismiss Moonshot but redirect to somewhere else.
  (step?: MoonshotSteps, options?: { redirect?: boolean }): void;
}
export interface MoonshotAnalyticsAttributes extends EventAttributes {
  idEnterprise: string | null;
  isEnterprise: boolean;
  orgId: string;
  confirmed: boolean | undefined;
}
export interface MoonshotContextState {
  currentStep: MoonshotSteps;
  onSubmit: MoonshotSubmitFunction;
  onDismiss: MoonshotDismissFunction;
  orgId: string;
  organization?: MoonshotOrganizationQuery['organization'];
  loading: boolean;
  idEnterprise: string | null;
  isEnterprise: boolean;
  moonshotCampaign?: NonNullable<MoonshotQuery['member']>['campaigns'][0];
  isFreeTrial: boolean;
  member?: MoonshotQuery['member'];
  setOrgId(id: string): void;
  analyticsAttributes: MoonshotAnalyticsAttributes | undefined;
}
